import { Card, Col, Nav, Row } from 'react-bootstrap';
import Login from '../Login/page';
import SignUp from '../SignUp/page';
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiClient } from '../api/apiclient';
import NoticeSection from '../NoticeSection/page';

function LandingPage() {
    const { institute } = useParams(); // Get the institute code from the route
    console.log("LandingPage ,institute== ", institute);
    const [currentPage, setCurrentPage] = useState("login");
    const [instituteData, setInstituteData] = useState(null);
    const [error, setError] = useState(null);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const [closedCourses, setClosedCourses] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchInstituteData = async () => {
            try {
                const response = await apiClient.get("/public/institutes");
                const data = response.data;
                console.log("fetchInstituteData==", data);

                // Find the institute by code from URL
                const selectedInstitute = data.find(
                    (item) => item.instituteCode === institute
                );
                console.log("selectedInstitute== ", selectedInstitute);
                if (selectedInstitute) {
                    setInstituteData(selectedInstitute);

                    // ✅ Store both id and code for later use (signup, login, etc.)
                    localStorage.setItem("instituteId", selectedInstitute.id);
                    console.log("instituteId== ", selectedInstitute.id);
                    localStorage.setItem("instituteCode", selectedInstitute.instituteCode);
                    console.log("instituteCode== ", selectedInstitute.instituteCode);
                } else {
                    setError("Institute not found");
                    navigate("/page-error");
                }
            } catch (err) {
                console.error("Error fetching institute data:", err);
                setError("Failed to fetch institute data");
                navigate("/page-error");
            }
        };

        fetchInstituteData();
    }, [institute, navigate]);

    if (error) {
        return <div style={{ color: "red", textAlign: "center", marginTop: "50px" }}>{error}</div>;
    }
    if (!instituteData) {
        return <div style={{ textAlign: "center", marginTop: "50px" }}>Loading...</div>;
    }
    const logoPath = `/Logos/${institute}.png`;

    return (
        <>

            <div className='banner_bg'>
                <Row>
                    <Col sm={12} xs={12} md={6} lg={6}>
                        <div>
                            <Col xs={12} md={6} className="text-center">
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div className="logo-container">
                                        <img className="logo" src={logoPath} alt={`${institute} Logo`} style={{ maxWidth: "200px", marginBottom: "20px", marginTop: "20px" }} />
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <h1 className="institute-name" style={{ fontSize: "35px", fontWeight: "700", color: "#fff", marginBottom: "10px" }}>
                                            {institute.toUpperCase()}
                                        </h1>
                                        <p className="institute-tagline" style={{ fontSize: "20px", color: "#fff", fontWeight: "500" }}>
                                            Welcome to {institute.toUpperCase()}!
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </div>

                        <div className="mt-8">
                            <NoticeSection setClosedCourses={setClosedCourses} />
                        </div>
                    </Col>
                    <Col sm={12} xs={12} md={6} lg={6}>
                        {/* <Login/> */}
                        {currentPage === "login" ? (
                            <Login onSwitchPage={() => handlePageChange("signup")} />
                        ) : (
                            <SignUp onSwitchPage={() => handlePageChange("login")} />
                        )}
                    </Col>
                </Row>

            </div>
        </>
    );
}

export default LandingPage;